module.exports = __webpack_public_path__ + "static/blue-circle-7ff923980eb18bb2ecfdab4402140369.png";